export const nameSpace = 'emergencies';
